import { gql } from "@apollo/client";

const DISCORD_SERVER_SETTINGS_FIELDS = `
  serverId
  serverName
  botInServer
  pendingServerId
  pendingServerName
  codeExpiresAt
  botInviteUrl
`;

export const GET_DISCORD_SERVER_SETTINGS = gql`
  query GetDiscordServerSettings {
    getDiscordServerSettings {
      ${DISCORD_SERVER_SETTINGS_FIELDS}
    }
  }
`;

export const REQUEST_DISCORD_SERVER_CODE = gql`
  mutation RequestDiscordServerCode($serverId: String!) {
    requestDiscordServerCode(serverId: $serverId) {
      ${DISCORD_SERVER_SETTINGS_FIELDS}
    }
  }
`;

export const CONFIRM_DISCORD_SERVER_CODE = gql`
  mutation ConfirmDiscordServerCode($code: String!) {
    confirmDiscordServerCode(code: $code) {
      ${DISCORD_SERVER_SETTINGS_FIELDS}
    }
  }
`;

export const CANCEL_DISCORD_SERVER_CHANGE = gql`
  mutation CancelDiscordServerChange {
    cancelDiscordServerChange {
      ${DISCORD_SERVER_SETTINGS_FIELDS}
    }
  }
`;
